import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import LoginComponent from '../pages/login';
import Layout from '../layout/Layout';
import Dashboard from '../pages/dashboard';
import Category from '../pages/category';
import AddCategory from '../pages/category/add';
import Size from '../pages/size';
import AddSize from '../pages/size/add';
import Series from '../pages/series';
import AddSeries from '../pages/series/add';
import Product from '../pages/product';
import AddProduct from '../pages/product/add';
import Profile from '../pages/settings/profile';
import ViewStock from '../pages/viewStock/viewStock';
import User from '../pages/user';
import UserAdd from "../pages/user/add";
import Upload from '../pages/imageupload/upload';
import Pdf from '../pages/pdf/pdf'
import PdfView from '../pages/pdf/pdfview'
const Router = () => {

    const Paths = [
        { path: '', component: <Dashboard /> },
        { path: 'dashboard', component: <Dashboard /> },

        { path: 'category', component: <Category /> },
        { path: 'category/add', component: <AddCategory /> },
        { path: 'category/edit/:id', component: <AddCategory /> },

        { path: 'size', component: <Size /> },
        { path: 'size/add', component: <AddSize /> },
        { path: 'size/edit/:id', component: <AddSize /> },

        { path: 'series', component: <Series /> },
        { path: 'series/add', component: <AddSeries /> },
        { path: 'series/edit/:id', component: <AddSeries /> },


        { path: 'product', component: <Product /> },
        { path: 'product/add', component: <AddProduct /> },
        { path: 'product/edit/:id', component: <AddProduct /> },

        { path: 'profile', component: <Profile /> },

        { path: 'view-stock', component: <ViewStock /> },

        { path: 'user', component: <User /> },
        { path: 'user/add', component: <UserAdd /> },
        { path: 'user/edit/:id', component: <UserAdd /> },

        { path: 'series/upload/:id', component: <Upload />},

        { path: 'pdf', component: <Pdf /> },
        { path: 'pdfview', component: <PdfView /> },


    ];

    return (
        <Routes>
            <Route path="/" element={<LoginComponent />}></Route>
            <Route path="/login" element={<LoginComponent />} />
            <Route path="admin" element={<Outlet />} >
                {
                    Paths.map((element) => {
                        return (
                            <Route key={element} path={element.path} element={<Layout component={element.component} />} />
                        );
                    })
                }
            </Route>
            <Route exact path="*" element={<h1>Not Found</h1>} />
        </Routes>
    );
}

export default React.memo(Router);